import { render, staticRenderFns } from "./LanguageSelector.vue?vue&type=template&id=79af4e57&"
import script from "./LanguageSelector.vue?vue&type=script&lang=ts&"
export * from "./LanguageSelector.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports